import React, { FC } from 'react';
import { KeyboardTimePicker, KeyboardTimePickerProps } from '@material-ui/pickers';
import { AccessTime } from '@material-ui/icons';

export type TimeFieldProps = KeyboardTimePickerProps;

export type TimePickerEventType = {
  eventTime: Date | null;
};

const DEFAULT_TIME_FORMAT = 'hh:mm a';
const DEFAULT_VARIANT_TYPE = 'inline';

const TimeField: FC<TimeFieldProps> = (props: TimeFieldProps) => {
  return (
    <KeyboardTimePicker
      autoOk
      keyboardIcon={<AccessTime />}
      format={DEFAULT_TIME_FORMAT}
      {...props}
      variant={DEFAULT_VARIANT_TYPE}
    />
  );
};

export default TimeField;
